module.exports = import("https://www.gstatic.com/firebasejs/10.8.0/firebase-database.js");;